import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ls-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SectionComponent {}
